import { SectionKey } from "libs/schema/src/sections";
import { CertificationsForm } from "./certifications";
import { EducationForm } from "./education";
import { ExperienceForm } from "./experience";
import { InterestsForm } from "./interests";
import { LanguagesForm } from "./languages";
import { ProfilesForm } from "./profiles";
import { ProjectsForm } from "./projects";
import { PublicationsForm } from "./publications";
import { ReferencesForm } from "./references";
import { SkillsForm } from "./skills";
import { VolunteerForm } from "./volunteer";
import { AwardsForm } from "./awards";
import { CustomSectionForm } from "./custom-section";

interface SectionItemFormProps {
  id: SectionKey;
}

export const SectionItemForm = ({ id }: SectionItemFormProps) => {
  if (id.includes("custom")) {
    return <CustomSectionForm id={id} />;
  }

  switch (id) {
    case "education":
      return <EducationForm id={id} />;
    case "experience":
      return <ExperienceForm id={id} />;
    case "certifications":
      return <CertificationsForm id={id} />;
    case "interests":
      return <InterestsForm id={id} />;
    case "projects":
      return <ProjectsForm id={id} />;
    case "awards":
      return <AwardsForm id={id} />;
    case "profiles":
      return <ProfilesForm id={id} />;
    case "skills":
      return <SkillsForm id={id} />;
    case "languages":
      return <LanguagesForm id={id} />;
    case "publications":
      return <PublicationsForm id={id} />;
    case "references":
      return <ReferencesForm id={id} />;
    case "volunteer":
      return <VolunteerForm id={id} />;
    // Add more cases for other ids and their corresponding components if required
    default:
      return null;
  }
};
